import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import React from 'react';
import ProductInfoModelSimpleTextSchema from './ProductInfoModelSimpleTextSchema';

const ProductInfoModelSimpleText = (props: ProductInfoModelSimpleTextProps) => {
    //
    return (
        <div className={props.className}>
            <label>
                {(!props.hideSKU && props?.data?.sku
                        ? props?.data?.sku
                        : '') +
                    (!props.hideName && props?.data?.name
                        ? ' ( ' + props?.data?.name + ' )'
                        : '')}
            </label>
        </div>
    );
};

export type ProductInfoModelSimpleTextProps = {
    data?: ProductInfoModelSimpleTextData;
} & ProductInfoModelSimpleTextDisplayOptions;
export default withInspector<ProductInfoModelSimpleTextProps>(
    ProductInfoModelSimpleText,
    ProductInfoModelSimpleTextSchema
);

export interface ProductInfoModelSimpleTextDisplayOptions {
    className?: string;
    //
    hideSKU?: boolean;
    hideName?: boolean;
}

export type ProductInfoModelSimpleTextData = {
    id?: string;
    sku?: string;
    name?: string;
};

export const ProductInfoModelSimpleTextDataKeys = ['id', 'sku', 'name'];
